webpackJsonp([1],{

/***/ 134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Calendar__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Calendar__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/:lang?',
    name: 'Calendar',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Calendar___default.a
  }]
}));

/***/ }),

/***/ 135:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(175)

var Component = __webpack_require__(133)(
  /* script */
  __webpack_require__(139),
  /* template */
  __webpack_require__(187),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 140:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_flatpickr_da__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_flatpickr_da___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_flatpickr_da__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_flatpickr_de__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_flatpickr_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_flatpickr_de__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);








__WEBPACK_IMPORTED_MODULE_5_moment__["locale"]('da');

var config = {
  apiKey: 'AIzaSyAynycu2fcbWAusFICFIN026B-sw32js8o',
  authDomain: 'hscamping-9c323.firebaseapp.com',
  databaseURL: 'https://hscamping-9c323.firebaseio.com',
  storageBucket: 'hscamping-9c323.appspot.com',
  messagingSenderId: '761576838574'
};
var firebaseApp = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.initializeApp(config);
var db = firebaseApp.database();

var usersRef = db.ref('users');
var activitiesRef = db.ref('activities');

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      currentLang: 'da',
      currentSearch: '',
      currentFromDate: '',
      currentToDate: '',
      currentVisible: '',
      today: __WEBPACK_IMPORTED_MODULE_5_moment__().format('YYYY-MM-DD'),
      aWeekFromNow: __WEBPACK_IMPORTED_MODULE_5_moment__().add(1, 'weeks').format('YYYY-MM-DD'),
      dataLoaded: false,
      fpOptions: {
        locale: __WEBPACK_IMPORTED_MODULE_3__assets_flatpickr_da__["da"],
        altInput: true,
        altFormat: 'j. F Y'
      },
      activeActivities: [],
      danishText: {
        search: 'søg',
        from: 'fra dato',
        to: 'til dato',
        time: 'Tidspunkt',
        location: 'Sted',
        price: 'Pris',
        info: 'Info',
        organiser: 'Arrangør',
        activitiesFor: 'Aktiviteter for...',
        visibleTo: 'Aktiviteter for',
        henneGuest: 'HSC gæster',
        fpGuest: 'Feriepartner gæster',
        others: 'Andre',
        maxParticipants: 'Maks deltagere',
        maxParticipantsSignUp: 'Tilmeld dig via appen eller i receptionen',
        freeWithPackage: 'gratis med aktivitetspakke',
        free: 'Gratis',
        noActivities: 'ingen aktiviteter'
      },
      germanText: {
        search: 'suche',
        from: 'von Datum',
        to: 'zu Datum',
        time: 'Zeit',
        location: 'Ort',
        price: 'Preis',
        info: 'Info',
        organiser: 'Veranstalter',
        activitiesFor: 'Aktivitäten für...',
        henneGuest: 'HSC Gäste',
        fpGuest: 'Feriepartner Gäste',
        others: 'Andere',
        visibleTo: 'Aktivitäten für',
        maxParticipants: 'Teilnehmergrenze',
        maxParticipantsSignUp: 'Anmeldung über den App oder an der Rezeption',
        freeWithPackage: 'kostenlos mit Aktivitätspaket',
        free: 'kostenlos',
        noActivities: 'keine aktivitäten'
      },
      currentText: {
        search: '',
        from: '',
        to: '',
        time: '',
        location: '',
        price: '',
        info: '',
        organiser: '',
        visibleTo: '',
        freeWithPackage: '',
        free: '',
        noActivities: ''
      }
    };
  },

  firebase: {
    activities: activitiesRef,
    users: usersRef
  },
  beforeMount: function beforeMount() {
    this.currentLang = this.$route.params.lang ? this.$route.params.lang : 'da';
    this.currentText = this.currentLang === 'de' ? this.germanText : this.danishText;
    this.fpOptions.locale = this.currentLang === 'de' ? __WEBPACK_IMPORTED_MODULE_4__assets_flatpickr_de__["de"] : __WEBPACK_IMPORTED_MODULE_3__assets_flatpickr_da__["da"];
  },
  mounted: function mounted() {
    var _this = this;

    activitiesRef.once('value', function (snapshot) {
      _this.dataLoaded = true;
    });
  },
  created: function created() {
    this.currentFromDate = this.today;
    this.currentToDate = this.aWeekFromNow;
  },

  methods: {
    getActivity: function getActivity(id) {
      return this.activities.find(function (activity) {
        return activity['.key'] === id;
      });
    },
    getActivities: function getActivities(date) {
      return this.activities.filter(function (activity) {
        return activity.date === date;
      }).sort(function (a, b) {
        if (a.startTimeInMinutes > b.startTimeInMinutes) {
          return 1;
        }
        if (a.startTimeInMinutes < b.startTimeInMinutes) {
          return -1;
        }
        return 0;
      });
    },
    toggleActive: function toggleActive(activity) {
      if (!this.isActiveActivity(activity)) {
        this.activeActivities.push(activity);
      } else {
        this.activeActivities.splice(this.activeActivities.indexOf(activity), 1);
      }
    },
    isActiveActivity: function isActiveActivity(activity) {
      return this.activeActivities.indexOf(activity) >= 0;
    },
    filter: function filter(activities) {
      var _this2 = this;

      if (this.currentFromDate !== '' && this.currentToDate !== '') {
        activities = activities.filter(function (activity) {
          return __WEBPACK_IMPORTED_MODULE_5_moment__(activity.date).isSameOrAfter(__WEBPACK_IMPORTED_MODULE_5_moment__(_this2.currentFromDate)) && __WEBPACK_IMPORTED_MODULE_5_moment__(activity.date).isSameOrBefore(__WEBPACK_IMPORTED_MODULE_5_moment__(_this2.currentToDate));
        });
      } else {
        activities = activities.filter(function (activity) {
          return __WEBPACK_IMPORTED_MODULE_5_moment__(activity.date).isSameOrAfter(__WEBPACK_IMPORTED_MODULE_5_moment__(_this2.today)) && __WEBPACK_IMPORTED_MODULE_5_moment__(activity.date).isSameOrBefore(__WEBPACK_IMPORTED_MODULE_5_moment__(_this2.today).add(1, 'months'));
        });
      }

      activities = activities.filter(function (activity) {
        return activity.title[_this2.currentLang] !== '';
      });

      if (this.currentSearch !== '') {
        activities = activities.filter(function (activity) {
          return activity.title[_this2.currentLang].toLowerCase().includes(_this2.currentSearch.toLowerCase());
        });
      }

      if (this.currentVisible == 'partner') {
        activities = activities.filter(function (activity) {
          return activity.visibleTo !== 'camping';
        });
        console.log(this.currentVisible.toLowerCase());
      }
      if (this.currentVisible == 'everyone') {
        activities = activities.filter(function (activity) {
          return activity.visibleTo !== 'camping' && 'partner';
        });
        console.log(this.currentVisible.toLowerCase());
      }
      if (this.currentVisible == 'camping') {
        activities = activities.filter(function (activity) {
          return activity.visibleTo !== 'partner';
        });
        console.log(this.currentVisible.toLowerCase());
      }
      return activities;
    },
    isPastActivity: function isPastActivity(activity) {
      return __WEBPACK_IMPORTED_MODULE_5_moment__(activity.date).add(activity.endTimeInMinutes, 'minutes').isBefore(__WEBPACK_IMPORTED_MODULE_5_moment__());
    },
    findUser: function findUser(participant, key) {
      var user = this.users.find(function (user) {
        return user['.key'] === participant.uid;
      });
      if (user === undefined) return { name: participant.uid, confirmed: participant.confirmed, key: key };
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, user, { confirmed: participant.confirmed, key: key });
    },
    getParticipants: function getParticipants(activity) {
      var _this3 = this;

      var participants = this.activities.find(function (act) {
        return act['.key'] === activity['.key'];
      }).participants;

      if (!participants) {
        return;
      }

      var participantsList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(participants).map(function (key) {
        return { key: key, value: participants[key] };
      });

      return participantsList.map(function (participant) {
        return _this3.findUser(participant.value, participant.key);
      }).sort(function (a, b) {
        if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return 1;
        }
        if (a.name.toLowerCase() < b.name.toLowerCase()) {
          return -1;
        }
        return 0;
      });
    },
    getParticipantsAmount: function getParticipantsAmount(activity) {
      var participants = this.activities.find(function (act) {
        return act['.key'] === activity['.key'];
      }).participants;
      if (!participants) return 0;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(participants).length;
    },
    timeInMinutesToTime: function timeInMinutesToTime(timeInMinutes) {
      var hours = Math.floor(timeInMinutes / 60).toString();
      var minutes = (timeInMinutes % 60).toString();

      hours = hours.length === 1 ? '0' + hours : hours;
      minutes = minutes.length === 1 ? '0' + minutes : minutes;

      return {
        HH: hours,
        mm: minutes
      };
    },
    resetCurrentDate: function resetCurrentDate() {
      this.$refs.flatpickrfrom.$el._flatpickr.setDate(this.today);
      this.$refs.flatpickrto.$el._flatpickr.setDate(this.aWeekFromNow);
    },
    localizeDate: function localizeDate(date) {
      var d = __WEBPACK_IMPORTED_MODULE_5_moment__(date);
      d.locale(this.currentLang);

      var dayOfWeek = d.format('dddd');
      var stringDate = d.format('LL');

      return dayOfWeek + ', ' + stringDate;
    }
  },
  computed: {
    dates: function dates() {
      var res = [];

      this.filter(this.activities).forEach(function (activity) {
        if (res.indexOf(activity.date) < 0) {
          res.push(activity.date);
        }
      });

      res.sort(function (a, b) {
        if (a > b) {
          return 1;
        }
        if (a < b) {
          return -1;
        }
        return 0;
      });

      return res;
    }
  }
});

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {


var Flatpickr = Flatpickr || { l10ns: {} };
Flatpickr.l10ns.da = {};

Flatpickr.l10ns.da.weekdays = {
	shorthand: ['søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør'],
	longhand: ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag']
};

Flatpickr.l10ns.da.months = {
	shorthand: ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
	longhand: ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december']
};

Flatpickr.l10ns.da.ordinal = function () {
	return ".";
};

Flatpickr.l10ns.da.firstDayOfWeek = 1;

if (true) {
	module.exports = Flatpickr.l10ns;
}

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {


var Flatpickr = Flatpickr || { l10ns: {} };
Flatpickr.l10ns.de = {};

Flatpickr.l10ns.de.weekdays = {
	shorthand: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
	longhand: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']
};

Flatpickr.l10ns.de.months = {
	shorthand: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
	longhand: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
};

Flatpickr.l10ns.de.firstDayOfWeek = 1;
Flatpickr.l10ns.de.weekAbbreviation = 'KW';
Flatpickr.l10ns.de.rangeSeparator = ' bis ';

if (true) {
	module.exports = Flatpickr.l10ns;
}

/***/ }),

/***/ 143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuefire__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_flatpickr__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_flatpickr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_flatpickr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_flatpickr_css__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_flatpickr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_flatpickr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuefire___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_flatpickr___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('minutesToTimeOfDay', function (minutes) {
  return __WEBPACK_IMPORTED_MODULE_7_moment__["utc"]().startOf('day').add(minutes, 'minutes').format("HH:mm");
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 174:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 175:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 17,
	"./af.js": 17,
	"./ar": 24,
	"./ar-dz": 18,
	"./ar-dz.js": 18,
	"./ar-kw": 19,
	"./ar-kw.js": 19,
	"./ar-ly": 20,
	"./ar-ly.js": 20,
	"./ar-ma": 21,
	"./ar-ma.js": 21,
	"./ar-sa": 22,
	"./ar-sa.js": 22,
	"./ar-tn": 23,
	"./ar-tn.js": 23,
	"./ar.js": 24,
	"./az": 25,
	"./az.js": 25,
	"./be": 26,
	"./be.js": 26,
	"./bg": 27,
	"./bg.js": 27,
	"./bn": 28,
	"./bn.js": 28,
	"./bo": 29,
	"./bo.js": 29,
	"./br": 30,
	"./br.js": 30,
	"./bs": 31,
	"./bs.js": 31,
	"./ca": 32,
	"./ca.js": 32,
	"./cs": 33,
	"./cs.js": 33,
	"./cv": 34,
	"./cv.js": 34,
	"./cy": 35,
	"./cy.js": 35,
	"./da": 36,
	"./da.js": 36,
	"./de": 39,
	"./de-at": 37,
	"./de-at.js": 37,
	"./de-ch": 38,
	"./de-ch.js": 38,
	"./de.js": 39,
	"./dv": 40,
	"./dv.js": 40,
	"./el": 41,
	"./el.js": 41,
	"./en-au": 42,
	"./en-au.js": 42,
	"./en-ca": 43,
	"./en-ca.js": 43,
	"./en-gb": 44,
	"./en-gb.js": 44,
	"./en-ie": 45,
	"./en-ie.js": 45,
	"./en-nz": 46,
	"./en-nz.js": 46,
	"./eo": 47,
	"./eo.js": 47,
	"./es": 49,
	"./es-do": 48,
	"./es-do.js": 48,
	"./es.js": 49,
	"./et": 50,
	"./et.js": 50,
	"./eu": 51,
	"./eu.js": 51,
	"./fa": 52,
	"./fa.js": 52,
	"./fi": 53,
	"./fi.js": 53,
	"./fo": 54,
	"./fo.js": 54,
	"./fr": 57,
	"./fr-ca": 55,
	"./fr-ca.js": 55,
	"./fr-ch": 56,
	"./fr-ch.js": 56,
	"./fr.js": 57,
	"./fy": 58,
	"./fy.js": 58,
	"./gd": 59,
	"./gd.js": 59,
	"./gl": 60,
	"./gl.js": 60,
	"./gom-latn": 61,
	"./gom-latn.js": 61,
	"./he": 62,
	"./he.js": 62,
	"./hi": 63,
	"./hi.js": 63,
	"./hr": 64,
	"./hr.js": 64,
	"./hu": 65,
	"./hu.js": 65,
	"./hy-am": 66,
	"./hy-am.js": 66,
	"./id": 67,
	"./id.js": 67,
	"./is": 68,
	"./is.js": 68,
	"./it": 69,
	"./it.js": 69,
	"./ja": 70,
	"./ja.js": 70,
	"./jv": 71,
	"./jv.js": 71,
	"./ka": 72,
	"./ka.js": 72,
	"./kk": 73,
	"./kk.js": 73,
	"./km": 74,
	"./km.js": 74,
	"./kn": 75,
	"./kn.js": 75,
	"./ko": 76,
	"./ko.js": 76,
	"./ky": 77,
	"./ky.js": 77,
	"./lb": 78,
	"./lb.js": 78,
	"./lo": 79,
	"./lo.js": 79,
	"./lt": 80,
	"./lt.js": 80,
	"./lv": 81,
	"./lv.js": 81,
	"./me": 82,
	"./me.js": 82,
	"./mi": 83,
	"./mi.js": 83,
	"./mk": 84,
	"./mk.js": 84,
	"./ml": 85,
	"./ml.js": 85,
	"./mr": 86,
	"./mr.js": 86,
	"./ms": 88,
	"./ms-my": 87,
	"./ms-my.js": 87,
	"./ms.js": 88,
	"./my": 89,
	"./my.js": 89,
	"./nb": 90,
	"./nb.js": 90,
	"./ne": 91,
	"./ne.js": 91,
	"./nl": 93,
	"./nl-be": 92,
	"./nl-be.js": 92,
	"./nl.js": 93,
	"./nn": 94,
	"./nn.js": 94,
	"./pa-in": 95,
	"./pa-in.js": 95,
	"./pl": 96,
	"./pl.js": 96,
	"./pt": 98,
	"./pt-br": 97,
	"./pt-br.js": 97,
	"./pt.js": 98,
	"./ro": 99,
	"./ro.js": 99,
	"./ru": 100,
	"./ru.js": 100,
	"./sd": 101,
	"./sd.js": 101,
	"./se": 102,
	"./se.js": 102,
	"./si": 103,
	"./si.js": 103,
	"./sk": 104,
	"./sk.js": 104,
	"./sl": 105,
	"./sl.js": 105,
	"./sq": 106,
	"./sq.js": 106,
	"./sr": 108,
	"./sr-cyrl": 107,
	"./sr-cyrl.js": 107,
	"./sr.js": 108,
	"./ss": 109,
	"./ss.js": 109,
	"./sv": 110,
	"./sv.js": 110,
	"./sw": 111,
	"./sw.js": 111,
	"./ta": 112,
	"./ta.js": 112,
	"./te": 113,
	"./te.js": 113,
	"./tet": 114,
	"./tet.js": 114,
	"./th": 115,
	"./th.js": 115,
	"./tl-ph": 116,
	"./tl-ph.js": 116,
	"./tlh": 117,
	"./tlh.js": 117,
	"./tr": 118,
	"./tr.js": 118,
	"./tzl": 119,
	"./tzl.js": 119,
	"./tzm": 121,
	"./tzm-latn": 120,
	"./tzm-latn.js": 120,
	"./tzm.js": 121,
	"./uk": 122,
	"./uk.js": 122,
	"./ur": 123,
	"./ur.js": 123,
	"./uz": 125,
	"./uz-latn": 124,
	"./uz-latn.js": 124,
	"./uz.js": 125,
	"./vi": 126,
	"./vi.js": 126,
	"./x-pseudo": 127,
	"./x-pseudo.js": 127,
	"./yo": 128,
	"./yo.js": 128,
	"./zh-cn": 129,
	"./zh-cn.js": 129,
	"./zh-hk": 130,
	"./zh-hk.js": 130,
	"./zh-tw": 131,
	"./zh-tw.js": 131
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 180;

/***/ }),

/***/ 183:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjNTU2Yjc5IiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCiAgICA8cGF0aCBkPSJNNyAxMGw1IDUgNS01eiIvPg0KICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4NCjwvc3ZnPg=="

/***/ }),

/***/ 184:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjNTU2Yjc5IiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCiAgICA8cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+DQogICAgPHBhdGggZD0iTTE5IDNoLTFWMWgtMnYySDhWMUg2djJINWMtMS4xMSAwLTEuOTkuOS0xLjk5IDJMMyAxOWMwIDEuMS44OSAyIDIgMmgxNGMxLjEgMCAyLS45IDItMlY1YzAtMS4xLS45LTItMi0yem0wIDE2SDVWOGgxNHYxMXpNNyAxMGg1djVIN3oiLz4NCjwvc3ZnPg=="

/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(174)

var Component = __webpack_require__(133)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(186),
  /* scopeId */
  "data-v-13d6a0f7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "search",
    staticStyle: {
      "margin-bottom": "25px",
      "float": "left"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSearch),
      expression: "currentSearch"
    }],
    staticStyle: {
      "display": "block",
      "margin-bottom": "5px",
      "min-width": "197px"
    },
    attrs: {
      "placeholder": _vm.currentText.search,
      "type": "text"
    },
    domProps: {
      "value": (_vm.currentSearch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentSearch = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "visible_to",
    staticStyle: {
      "margin-bottom": "25px",
      "float": "left"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentVisible),
      expression: "currentVisible"
    }],
    staticClass: "lang-dropdown",
    staticStyle: {
      "border": "1px solid #556b79",
      "padding": "8px",
      "font-size": "1.2em"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentVisible = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.currentText.activitiesFor))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "camping"
    }
  }, [_vm._v(_vm._s(_vm.currentText.henneGuest))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "partner"
    }
  }, [_vm._v(_vm._s(_vm.currentText.fpGuest))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "everyone"
    }
  }, [_vm._v(_vm._s(_vm.currentText.others))])])]), _vm._v(" "), _c('div', {
    staticClass: "date-picker",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-20px",
      "width": "100px"
    }
  }, [_vm._v(_vm._s(_vm.currentText.from))]), _c('Flatpickr', {
    ref: "flatpickrfrom",
    attrs: {
      "options": _vm.fpOptions
    },
    model: {
      value: (_vm.currentFromDate),
      callback: function($$v) {
        _vm.currentFromDate = $$v
      },
      expression: "currentFromDate"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "-20px",
      "width": "100px"
    }
  }, [_vm._v(_vm._s(_vm.currentText.to))]), _c('Flatpickr', {
    ref: "flatpickrto",
    attrs: {
      "options": _vm.fpOptions
    },
    model: {
      value: (_vm.currentToDate),
      callback: function($$v) {
        _vm.currentToDate = $$v
      },
      expression: "currentToDate"
    }
  }), _vm._v(" "), (_vm.currentFromDate != _vm.today || _vm.currentToDate != _vm.aWeekFromNow) ? _c('img', {
    attrs: {
      "src": __webpack_require__(184)
    },
    on: {
      "click": _vm.resetCurrentDate
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.dates), function(date) {
    return _c('div', {
      staticClass: "date"
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(_vm.localizeDate(date)))]), _vm._v(" "), _vm._l((_vm.filter(_vm.getActivities(date))), function(activity) {
      return _c('div', {
        staticClass: "activity",
        class: {
          past: _vm.isPastActivity(activity), activeActivity: _vm.isActiveActivity(activity)
        },
        on: {
          "click": function($event) {
            _vm.toggleActive(activity)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": activity.pic,
          "alt": "aktivitet"
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "content"
      }, [_c('div', {
        staticClass: "title"
      }, [_vm._v(_vm._s(activity.title[_vm.currentLang]))]), _vm._v(" "), _c('div', {
        staticStyle: {
          "font-size": "1.2em"
        }
      }, [_vm._v(_vm._s(_vm._f("minutesToTimeOfDay")(activity.startTimeInMinutes)) + " - " + _vm._s(_vm._f("minutesToTimeOfDay")(activity.endTimeInMinutes)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(activity.about[_vm.currentLang]))]), _vm._v(" "), (_vm.isActiveActivity(activity)) ? [_c('div', {
        staticClass: "info"
      }, [_c('span', {
        staticClass: "heading"
      }, [_vm._v(_vm._s(_vm.currentText.time))]), _c('span', {
        staticClass: "text"
      }, [_vm._v(_vm._s(_vm.localizeDate(date)) + ", " + _vm._s(_vm._f("minutesToTimeOfDay")(activity.startTimeInMinutes)) + " - " + _vm._s(_vm._f("minutesToTimeOfDay")(activity.endTimeInMinutes)))])]), _vm._v(" "), _c('div', {
        staticClass: "info"
      }, [_c('span', {
        staticClass: "heading"
      }, [_vm._v(_vm._s(_vm.currentText.info))]), _c('span', {
        staticClass: "text",
        staticStyle: {
          "white-space": "pre-wrap"
        }
      }, [_vm._v(_vm._s(activity.info[_vm.currentLang]))])]), _vm._v(" "), _c('div', {
        staticClass: "info"
      }, [_c('span', {
        staticClass: "heading"
      }, [_vm._v(_vm._s(_vm.currentText.location))]), _c('span', {
        staticClass: "text"
      }, [_vm._v(_vm._s(activity.location[_vm.currentLang]))])]), _vm._v(" "), _c('div', {
        staticClass: "info"
      }, [_c('span', {
        staticClass: "heading"
      }, [_vm._v(_vm._s(_vm.currentText.organiser))]), _c('span', {
        staticClass: "text"
      }, [_vm._v(_vm._s(activity.organiser))])]), _vm._v(" "), (activity.maxAmountOfParticipants) ? _c('div', {
        staticClass: "info"
      }, [_c('span', {
        staticClass: "heading"
      }, [_vm._v(_vm._s(_vm.currentText.maxParticipants))]), _c('span', {
        staticClass: "text"
      }, [_vm._v(_vm._s(activity.maxAmountOfParticipants) + " (" + _vm._s(_vm.currentText.maxParticipantsSignUp) + ")")])]) : _vm._e(), _vm._v(" "), (activity.price !== 0 || activity.priceCategory === 'freeForAll') ? _c('div', {
        staticClass: "info"
      }, [_c('span', {
        staticClass: "heading"
      }, [_vm._v(_vm._s(_vm.currentText.price))]), _vm._v(" "), _c('span', {
        staticClass: "text"
      }, [(activity.priceCategory !== 'freeForAll') ? _c('span', [_vm._v(_vm._s(activity.price) + " DKK\n                    "), (activity.priceCategory === 'freeWithPackage') ? _c('span', [_vm._v("(" + _vm._s(_vm.currentText.freeWithPackage) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (activity.priceCategory === 'freeForAll') ? _c('span', [_vm._v(_vm._s(_vm.currentText.free))]) : _vm._e()])]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('img', {
        staticClass: "arrow",
        staticStyle: {
          "position": "absolute",
          "bottom": "0",
          "right": "0",
          "width": "22px",
          "height": "22px",
          "user-select": "none"
        },
        attrs: {
          "src": __webpack_require__(183)
        }
      })])
    })], 2)
  }), _vm._v(" "), (!_vm.dataLoaded) ? _c('div', {
    staticClass: "spinner"
  }) : _vm._e(), _vm._v(" "), ((_vm.dataLoaded && _vm.dates && _vm.dates.length === 0 && _vm.currentFromDate !== '' && _vm.currentToDate !== '') || (_vm.currentFromDate === '' && _vm.currentToDate === '' && _vm.dataLoaded && _vm.dates.length === 0)) ? _c('div', [_vm._v(_vm._s(_vm.currentText.noActivities))]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 187:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ })

},[143]);


// WEBPACK FOOTER //
// static/js/app.e14bfe46abddeff9065c.js